function PageNotFound() {
  return <div>the page was not found</div>;
}

export default PageNotFound;
